import { registerComponent } from '@gig/magic-common';
import ReconnectLoaderComponent from './reconnect-loader.vue.js';

var ReconnectLoader = registerComponent(ReconnectLoaderComponent);

export { ReconnectLoader };
